/*
 * ===============================================================================================================
 *                                Copyright 2020, Blue Yonder Group, Inc.
 *                                           All Rights Reserved
 *
 *                               THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF
 *                                          BLUE YONDER GROUP, INC.
 *
 *
 *                         The copyright notice above does not evidence any actual
 *                                 or intended publication of such source code.
 *
 * ===============================================================================================================
 */

import interpolateString from '../utility/stringInterpolation';
import {
    MONTH_LIST,
    EXPIRING_TODAY_MESSAGE,
    EXPIRED_TODAY_MESSAGE,
    EXPIRED_MESSAGE,
    EXPIRES_IN_DAYS_MESSAGE
} from './constants';

export const convertTimeStamp = (dateObject: Date) => {
    let dateObj = new Date(dateObject);
    let month = MONTH_LIST[dateObj.getUTCMonth()];
    let day = dateObj.getUTCDate();
    let year = dateObj.getUTCFullYear();
    return month + ', ' + day + ' ' + year;
};

export const toSeconds = (hours: number, minutes: number) => {
    let seconds: any = hours * 3600 + minutes * 60;
    return seconds;
};

export const addDaysToDate = (dateObject: Date, noOfDays: number) => {
    const result = new Date(dateObject);
    result.setDate(result.getDate() + noOfDays);
    return result;
};

export const getExpiryMessage = (dateObject: Date) => {
    let currentDate = new Date();
    let dateObj = new Date(dateObject);
    const diffDays = Math.floor(
        (Date.UTC(dateObj.getFullYear(), dateObj.getMonth(), dateObj.getDate()) -
            Date.UTC(currentDate.getFullYear(), currentDate.getMonth(), currentDate.getDate())) /
        (1000 * 60 * 60 * 24)
    );
    const diffTime =
        toSeconds(dateObj.getHours(), dateObj.getMinutes()) - toSeconds(currentDate.getHours(), currentDate.getMinutes());

    if (diffDays >= 1) {
        return interpolateString([`${diffDays}`], EXPIRES_IN_DAYS_MESSAGE)
    } else if (diffDays === 0) {
        if (diffTime > 0) {
            return EXPIRING_TODAY_MESSAGE;
        } else return EXPIRED_TODAY_MESSAGE;
    } else {
        return EXPIRED_MESSAGE;
    }
};